import { render, staticRenderFns } from "./DocumentImport.vue?vue&type=template&id=fcb2e18e"
import script from "./DocumentImport.vue?vue&type=script&lang=js"
export * from "./DocumentImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports